export enum ReportsUserActivityRoutes {
    userActivityByUsers = "user-activity-by-users",
    userActivityByDate = "user-activity-by-date",
    userActivityByActivityType = "user-activity-by-activity-type",
}

export enum ReportsOpportunityPermissions {
    userActivityByUsers = "User Activity by Users",
    userActivityByDate = "User Activity by Date",
    userActivityByActivityType = "User Activity by Activity Type",
}
